import Animation from './animation'
import { transition } from 'd3-transition'

/*
 * This animation is used when a reference brand is split "per-serie", but then
 * the seriesRefId is removed, so the lines are drawn across the entire x-axis
 * tick.
 */
class RemoveSplitByAnimation extends Animation {

  match (serie) {
    if (!this.chart.previous) {
      return false
    }

    let group = this.series.selection()
                           .filter(s => s.id == serie.id)
                           .selectAll('.reference-group')

    if (!group.size()) {
      return false
    }

    let split0 = group.attr('data-split-by-serie') == 'true'
      , split1 = serie.points.every(p => typeof p.seriesRefId == 'undefined') // if all undefined, we're not split

    return split0 && split1 // previously split, but no longer
  }

  _getPreviousXExtent (rangeId, seriesRefId) {
    let x0 = this.groupScale(rangeId) + this.previousRefSerieScale(seriesRefId)
      , x1 = this.groupScale(rangeId) + this.previousRefSerieScale(seriesRefId) + this.previousRefSerieScale.bandwidth()
    return [x0, x1]
  }

  _transformLines (selection, serie) {
    selection.attr('d', (d, i) => {
      let [x0, x1] = this._getPreviousXExtent(d.rangeId, d.seriesRefId)
        , point = serie.points.find(p => p.rangeId == d.rangeId)
        , y = this.yScale(point.thresholds[i].raw)

      return this.line([[x0, y], [x1, y]])
    })
  }

  _transformFills (selection, serie) {
    selection.attr('d', (d, i, all) => {
      let [x0, x1] = this._getPreviousXExtent(d.rangeId, d.seriesRefId)
        , point = serie.points.find(p => p.rangeId == d.rangeId)
        , bounds = this._getBounds(point, d.idx, all)
        , y0 = this.yScale(bounds[0])
        , y1 = this.yScale(bounds[1])
      return this.area([[x0, y1, y0], [x1, y1, y0]])
    })
  }

  animate (serie, enter, selection, merged, exit) {
    merged.selectAll('path.line').call(this._transformLines.bind(this), serie)
    merged.selectAll('path.fill').call(this._transformFills.bind(this), serie)

    exit.selectAll('path.fill').call(this._transformFills.bind(this), serie)
    exit.selectAll('path.line')
        .call(this._transformLines.bind(this), serie)
        .end().then(() => {
          let t = transition().duration(0)
          merged.selection().selectAll('path.line').style('opacity', d => d.opacity)
          merged.selection().selectAll('path.fill').style('opacity', d => d.opacity)
          this._fills(merged.selection(), t)
          this._lines(merged.selection(), t)
          t.end().then(() => {
            exit.selection().remove()
          }).catch(() => {
            // interrupted transition, ignore
          })
        })
  }

}

export default RemoveSplitByAnimation
